import React from 'react';
import { TBaseProgressProps } from './BaseProgress.types';
import s from './BaseProgress.module.scss';
import classNames from 'classnames';

export const BaseProgress: React.FC<TBaseProgressProps> = ({ className = '', progress }) => {
  return (
    <div className={classNames(className, s.progress)}>
      <div style={{ width: `${progress}%` }} className={s.bar}></div>
    </div>
  );
};
